// Module
var code = "<template id=\"work-template\"> <div class=\"works__work\"> <div class=\"works__work__image\"></div> <div class=\"works__work__title h2 medium black\"></div> </div> </template> ";
// Exports
export default code;